import { devfolioFetch } from "./devfolioApi";

/**
 * Fetches all employees from BigQuery (directory_employees).
 * @returns {Promise<{ok: boolean, employees: Array}>}
 */
export async function getAllEmployees() {
  try {
    const data = await devfolioFetch("employees");
    const employees = Array.isArray(data.employees) ? data.employees : [];
    return { ok: data.ok === true, employees };
  } catch (err) {
    console.error("Error fetching all employees:", err);
    return { ok: false, employees: [] };
  }
}
